import { useAdminProfileDraftInterestActions } from 'slices/admin/profile/draft/interestSlice';

export default () => {
  const actions = useAdminProfileDraftInterestActions();

  return actions;
};
